import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import DriverApp from './DriverApp';
import reportWebVitals from './reportWebVitals';
import WebFont from 'webfontloader';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './i18n';

WebFont.load({
    google: {
        families: ['Poppins', 'sans-serif']
    }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <meta name="viewport" content="viewport-fit=cover, width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no" />
    <DriverApp />
  </React.StrictMode>
);

serviceWorkerRegistration.register({
  onUpdate: registration => {
    console.log(registration);
    const waitingServiceWorker = registration.waiting

    if (waitingServiceWorker) {
      waitingServiceWorker.addEventListener("statechange", event => {
        if (event.target.state === "activated") {
          window.location.reload()
        }
      });
      waitingServiceWorker.postMessage({ type: "SKIP_WAITING" });
    }
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
